export const MOST_NEGATIVE_SINGLE_FLOAT = -3.4028234663852886e38;
export const MOST_POSITIVE_SINGLE_FLOAT = -MOST_NEGATIVE_SINGLE_FLOAT;
//# sourceMappingURL=constants.js.map